<nz-tag>
  <i
    nz-icon
    [nzType]="cvcAttrValue | evidenceEnumDisplay : 'icon-name'"></i>
  {{ cvcAttrValue | evidenceEnumDisplay }}
</nz-tag>
